import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { Box, Container, Stack, Toolbar, useMediaQuery, useTheme } from '@mui/material';

import { useRouter } from '@cvt/routing';

import { Authenticated } from '@modules/Auth/components';

import { Header } from '../Header';
import { NavigationSidebar } from '../NavigationSidebar';


export const MainLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  const location = useLocation();
  const theme = useTheme();
  const isDesktopUp = useMediaQuery(theme.breakpoints.up('sm'));
  const [navigationOpen, setNavigationOpen] = React.useState(isDesktopUp);

  const openNavigation = () => {
    setNavigationOpen(true);
  };

  const closeNavigation = () => {
    setNavigationOpen(false);
  };

  const toggleNavigation = () => {
    setNavigationOpen(open => !open);
  };


  const hideHeader = React.useMemo(() => {
    const paths: string[] = [
      router.leadForm.byPartner().path,
      `${router.homeownerHub.path}/*`,
      router.partnerPortal.path,
    ];
    return paths.some((path) => matchPath(path, location.pathname));
  }, [location, router]);

  const hideSidebar = React.useMemo(() => {
    const paths: string[] = [
      router.leadForm.byPartner().path,
      `${router.projects.view().path}/*`,
      `${router.homeownerHub.path}/*`,
      router.partnerPortal.path,
    ];
    return paths.some((path) => matchPath(path, location.pathname));
  }, [location, router]);

  return (
    <React.Fragment>
      {!hideHeader && (
        <Authenticated>
          <Header
            onNavigationClickRequest={hideSidebar ? undefined : toggleNavigation}
            navigationOpen={navigationOpen}
          />
        </Authenticated>
      )}
      <Stack direction="row">
        <Authenticated>
          {!hideSidebar && (
            <NavigationSidebar
              open={navigationOpen}
              onOpenRequest={openNavigation}
              onCloseRequest={closeNavigation}
            />
          )}
        </Authenticated>
        <Box component="main" sx={{ width: '100%', minWidth: 0, bgcolor: theme.palette.background.paper }}>
          {!hideHeader && (
            <Toolbar/>
          )}
          <Container maxWidth={false} disableGutters sx={{ minHeight: 'calc(100vh - 64px)' }}>
            <Box>
              {children}
            </Box>
          </Container>
        </Box>
      </Stack>
    </React.Fragment>
  );
};
